module.exports = __webpack_public_path__ + "img/t3.49724600.png";